// import { useQuery } from '@tanstack/react-query';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useMemo } from 'react';
// import { toast } from 'react-toastify';
// import { collect } from 'collect.js';
// import { format, parseISO } from 'date-fns';

// import { Order } from '../../../../models/Order/Order';
// import { OrderForm } from '../CreateOrder/components';
// import { Product } from '../../../../models/Product/Product';

// // Helper funkcija koja pretvara podatke narudžbe u format koji forma očekuje
// const transformOrderToInitialValues = (order: Order) => {
//   if (!order) return null;

//   const attributesCollection = collect(
//     order.products.flatMap((p) => p.attributes ?? [])
//   );
//   const featuresCollection = collect(
//     order.products.flatMap((p) => p.features ?? [])
//   );

//   // Koristimo nullish coalescing operator (??) da osiguramo da nijedna vrijednost nije null/undefined
//   return {
//     id: order.id,
//     number_of_order: order.number_of_order ?? 0,
//     full_name: order.full_name ?? '',
//     email: order.email ?? '',
//     phone: order.phone ?? '',
//     type: order.type ?? 'individual',
//     personal_id_number: order.personal_id_number ?? '',
//     company_name: order.company_name ?? '',
//     company_tax_number: order.company_tax_number ?? '',
//     company_id_number: order.company_id_number ?? '',
//     state: order.state ?? '',
//     city: order.city ?? '',
//     zip: order.zip ?? '',
//     address: order.address ?? '',
//     note: order.note ?? '',
//     washing_fee: order.washing_fee ?? false,
//     reservation_start: order.reservation_start
//       ? format(parseISO(order.reservation_start), 'yyyy-MM-dd')
//       : '',
//     reservation_end: order.reservation_end
//       ? format(parseISO(order.reservation_end), 'yyyy-MM-dd')
//       : '',

//     // Polja za proizvode koji se šalju na backend
//     products: order.productsPivot.map((p) => ({
//       id: p.id,
//       quantity: p.pivot.quantity
//     })),

//     // Strukture za atribute i karakteristike
//     attributes: attributesCollection.pluck('attribute_id').unique().toArray(),
//     attribute_values: attributesCollection
//       .groupBy('attribute_id')
//       .map((group: any) => group.pluck('id').toArray())
//       .all(),
//     features: featuresCollection.pluck('feature_id').unique().toArray(),
//     feature_values: featuresCollection
//       .groupBy('feature_id')
//       .map((group: any) => group.pluck('id').toArray())
//       .all()
//   };
// };

// const EditOrder = () => {
//   const { id } = useParams<{ id: string }>();
//   const navigate = useNavigate();

//   const {
//     data: order,
//     isLoading,
//     isError
//   } = useQuery({
//     queryKey: ['order', id],
//     queryFn: () => Order.getOne(id!),
//     enabled: !!id,
//     staleTime: 1000 * 60
//   });

//   const initialValues = useMemo(() => {
//     return order ? transformOrderToInitialValues(order) : null;
//   }, [order]);

//   if (isLoading) {
//     return (
//       <div className="cs-inner-container">
//         Učitavanje podataka o narudžbi...
//       </div>
//     );
//   }

//   if (isError || !order) {
//     return (
//       <div className="cs-inner-container">Greška: Narudžba nije pronađena.</div>
//     );
//   }

//   if (order.status !== 'pending') {
//     return (
//       <div className="cs-inner-container">
//         <h2>Uređivanje nije dozvoljeno</h2>
//         <p>
//           Ova narudžba se ne može uređivati jer njen status više nije "pending".
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="cs-inner-container">
//       <h1 className="cs-title">
//         Uredi narudžbinu broj: {order.number_of_order}
//       </h1>
//       <p>
//         Ovdje možete urediti detalje narudžbe dok je još u "pending" statusu.
//       </p>
//       <hr />

//       {initialValues && (
//         <OrderForm
//           isEditing={true}
//           initialValues={initialValues}
//           onAfterSubmit={(payload) => {
//             toast.success('Narudžba je uspešno ažurirana!');
//             navigate(`/admin/orders/${payload.orderId}`);
//           }}
//         />
//       )}
//     </div>
//   );
// };

// export default EditOrder;
const EditOrder = () => <></>;
export default EditOrder;
